import React, { useEffect, useState } from "react";

// components
import MaterialTable from 'material-table';
import { table_translate } from "constants/MaterialTable.js";
import PendenciasLoja from "./PendenciasLoja";
import { Spinner} from "reactstrap";
import { formateDate } from "utils/formats";


export default function PendenciasGE({ list_table, startDate, endDate }) {

    const [showLoading, setshowLoading] = useState(false);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <MaterialTable style={{ minHeight: "auto" }}
                title=""
                columns={[
                    { title: 'Grupo Econômico', field: 'grupoEconomico' },
                    { title: 'Qtd PDV', field: 'qtdePdv'},
                    { title: 'Qtd PDV c/ Pendencia', field: 'qtdePdvPendencia'},
                    { title: 'Status DRE', field: 'statusDRE'}
                ]}
                data={list_table}
                isLoading={false}
                localization={table_translate}
                options={{
                    filtering: false,
                    search: false,
                    showTitle: false,
                    exportButton: false,
                    toolbar: false,
                    paging: false,
                    headerStyle: {
                        fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
                        fontWeight: '700',
                        color: '#fff',
                        backgroundColor: "#0b3d86",
                        paddingTop: '5px',
                        paddingBottom: '5px',
                        zIndex: 0
                    },
                }}
                detailPanel={rowData => {
                    return (
                        <div style={{ marginLeft: '80px' }}>
                            {<PendenciasLoja grupoEconomico={rowData.grupoEconomico}  startDate={startDate} endDate={endDate}></PendenciasLoja>}
                        </div>
                    )
                }}
            />

        </>

    );
}